import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Box, Group, Text, Flex, Avatar, Divider, ScrollArea, Menu, ActionIcon, Paper, Textarea } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";
import { safeValue, stringDivider, sqlDateToHumanDate, getObjectParam2, masaGaransiUtils__2, masaGaransiUtils__1, regexNumberOnly } from "../../utils/globalFunctions";

import { canAccessModifyPengerjaan } from "../../utils/accessing";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import PaperWrapper from "../../components/utilities/PaperWrapper";
import LabelContentInline from "../../components/general/LabelContentInline";
import InputComponent from "../../components/general/InputComponent";

const HistoryProjectCustomerData = ({ stateData, fnSuccessKlaimFromPengerjaanHistory }) => {

  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorSubmit: 'historyProjectCustomerData-1',
  })

  const [data, setData] = React.useState({
    klaimGaransiModal: false,
    klaimGaransiSubmitLoading: false,
    klaimGaransiSubmitError: false,

    stockId: '',
    customerId: '',
    projectIdHistory: '',
    projectId: '',
    projectPengerjaanStockId: '',

    itemGaransiName: '',
    itemGaransiStatus: '',
    itemGaransiType: '',
    itemGaransiBulan: '',
    itemGaransiHari: '',
    itemGaransiCanBeClaimedSupplier: '',
    itemGaransiCanBeClaimedCustomer: '',
    itemGaransiTanggalBeli: '',
    itemGaransiTanggalSelesai: '',
    itemGaransiJumlah: '',
    itemGaransiKeterangan: '',
    itemReferensi: '',

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  })

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const klaimGaransiHistoryStock = () => {
    setData(d => ({ ...d, klaimGaransiSubmitError: '' }));

    if (parseInt(Number(data.itemGaransiJumlah)) <= 0) {
      setData(d => ({ ...d, klaimGaransiSubmitError: 'Jumlah item wajib diisi.' }));
    } else if (validator.isEmpty(data.itemGaransiKeterangan, { ignore_whitespace: true })) {
      setData(d => ({ ...d, klaimGaransiSubmitError: 'Keterangan wajib diisi' }));
    } else {
      setData(d => ({
        ...d,
        klaimGaransiSubmitLoading: true,
      }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);

      //  formDT.append('pengerjaan_id', data.batalPemakaianItemData.pengerjaanId);
      //  formDT.append('pengerjaan_stock_id', data.batalPemakaianItemData.pengerjaanStockId);
      //  formDT.append('pengerjaan_progress_flag', utils.pengerjaanProgress.pengerjaan.value);
      //  formDT.append('pembatalan_type_list', JSON.stringify(utils.batalPemakaianItem));

      formDT.append('stock_id', data.stockId);
      formDT.append('jumlah_pemakaian_item', data.itemGaransiJumlah);
      formDT.append('pembatalan_type', data.itemGaransiType);
      formDT.append('keterangan_pembatalan', data.itemGaransiKeterangan);

      formDT.append('customer_id', data.customerId);

      formDT.append('project_id_history', data.projectIdHistory);
      formDT.append('project_process_history', utils.projectProcess.sudah_diambil.value);

      formDT.append('project_id', data.projectId);
      formDT.append('project_process', utils.projectProcess.pengerjaan.value);
      formDT.append('project_is_cancel', 0);

      formDT.append('project_pengerjaan_stock_id', data.projectPengerjaanStockId);

      formDT.append('status_item_garansi_pengajuan', utils.statusItemGaransi.pengajuan_klaim_garansi.value);
      formDT.append('garansi_reference', data.itemReferensi);

      formDT.append('flag_garansi_referensi_pengerjaan_history', utils.garansiReference.project_pengerjaan_history.value);
      formDT.append('flag_garansi_referensi_tambahan_stok', utils.garansiReference.project_tambahan_stock.value);

      axios({
        method: 'post',
        url: BE_API_THREE + '/klaim_garansi_from_pengerjaan_history',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, klaimGaransiSubmitLoading: false, klaimGaransiModal: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            stockId: '',
            customerId: '',
            projectIdHistory: '',
            projectId: '',
            projectPengerjaanStockId: '',

            itemGaransiName: '',
            itemGaransiStatus: '',
            itemGaransiType: '',
            itemGaransiBulan: '',
            itemGaransiHari: '',
            itemGaransiCanBeClaimedSupplier: '',
            itemGaransiCanBeClaimedCustomer: '',
            itemGaransiTanggalBeli: '',
            itemGaransiTanggalSelesai: '',
            itemGaransiJumlah: '',
            itemGaransiKeterangan: '',
            itemReferensi: '',
          }));

          fnSuccessKlaimFromPengerjaanHistory();
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorSubmit,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'cannot-be-claimed') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Item tidak dapat diklaim oleh customer.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'sepertinya-telah-terjadi-kesalahan') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Sepertinya telah terjadi kesalahan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'input-lebih-besar-dari-aktual') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: `Jumlah yang Anda masukkan lebih besar dari jumlah seharusnya !`,
              show: true
            }
          }))
        }
        //

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          klaimGaransiSubmitLoading: false,
          klaimGaransiModal: false
        }))

        notifications.show({
          id: notificationId.current.errorSubmit,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  const CompItem = ({ stateLabel, stateContent, stateMB = '0.25rem' }) => {
    return (
      <Group mb={stateMB} noWrap={true} align='flex-start' spacing={12}>
        <Text size='sm' fw={500} sx={{ whiteSpace: 'nowrap' }}>
          {stateLabel}
        </Text>

        <Text size='sm' color="dimmed">
          {stateContent}
        </Text>
      </Group>
    )
  }

  const CompItemInGaransi = ({ stateIndex, stateKey }) => {
    return (
      <Paper
        key={stateIndex}
        mt='.25rem'
        p='xs'
        sx={(tema) => ({
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: tema.colorScheme === 'light' ? tema.colors.gray[2] : tema.colors.dark[4],
          borderRadius: tema.radius.sm,
          fontSize: tema.fontSizes.sm,
          backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[5],
        })}
      >
        <Text size='xs' color="dimmed">
          Tanggal pengajuan klaim : {sqlDateToHumanDate({
            stateDate: stateKey.stock_garansi_tanggal_pengajuan,
            stateWithTime: false,
            stateLang: 'id',
            stateIsShort: false,
            stateDay: false,
            stateDefaultValue: ' - ',
            stateDateType: 'day',
            stateWithSecond: false
          })}
        </Text>

        <Text size='xs' color="dimmed">
          Tanggal kirim klaim ke supplier : {sqlDateToHumanDate({
            stateDate: stateKey.tanggal_kirim_ke_supplier,
            stateWithTime: false,
            stateLang: 'id',
            stateIsShort: false,
            stateDay: false,
            stateDefaultValue: ' - ',
            stateDateType: 'day',
            stateWithSecond: false
          })}
        </Text>

        <Text size='xs' color="dimmed">
          Tanggal tiba dari klaim supplier : {sqlDateToHumanDate({
            stateDate: stateKey.tanggal_tiba_dari_supplier,
            stateWithTime: false,
            stateLang: 'id',
            stateIsShort: false,
            stateDay: false,
            stateDefaultValue: ' - ',
            stateDateType: 'day',
            stateWithSecond: false
          })}
        </Text>
      </Paper>
    )
  }

  return (
    <React.Fragment>
      <ScrollArea.Autosize
        offsetScrollbars
        sx={{
          maxHeight: '50vh',
          width: '100%',
        }}
      >
        {Object.keys(stateData.data).map((keyH, indexH) => {
          return (
            <PaperWrapper
              key={keyH}
              stateMT={Number(indexH) === 0 ? '0' : 'sm'}
            >
              <Flex
                wrap='nowrap'
                gap="sm"
                justify="flex-start"
                align="flex-start"
              >
                <Box>
                  <Avatar radius="xl" size='sm' color="blue">{Number(keyH) + 1}</Avatar>
                </Box>

                {/* suspect flex: 1 atau width: '100%' atau flexGrow: 1 */}
                <Box sx={{ flex: 1 }}>
                  <Text size='sm' fw={500}>
                    {stringDivider(stateData.data[keyH].project_id, [4, 6, 8], '.', '[Nomor Nota]')}
                  </Text>
                </Box>
              </Flex>

              <Divider my='xs' />

              <CompItem
                stateLabel='Kategori Barang : '
                stateContent={stateData.data[keyH].barang_category_name}
              />

              <CompItem
                stateLabel='Nama Barang : '
                stateContent={stateData.data[keyH].barang_nama}
              />

              <CompItem
                stateLabel='Keluhan : '
                stateContent={stateData.data[keyH].barang_keluhan}
              />

              <CompItem
                stateLabel='Jenis Servis : '
                stateContent={getObjectParam2(utils.projectType, stateData.data[keyH].service_category, 'caption', ' - ')}
              />

              <CompItem
                stateLabel='Tanggal Masuk : '
                stateContent={sqlDateToHumanDate({
                  stateDate: stateData.data[keyH].tanggal_nota,
                  stateWithTime: false,
                  stateLang: 'id',
                  stateIsShort: false,
                  stateDay: false,
                  stateDefaultValue: ' - ',
                  stateDateType: 'day',
                  stateWithSecond: false
                })}
              />

              <CompItem
                stateLabel='Tanggal Selesai : '
                stateContent={sqlDateToHumanDate({
                  stateDate: stateData.data[keyH].tanggal_selesai,
                  stateWithTime: false,
                  stateLang: 'id',
                  stateIsShort: false,
                  stateDay: false,
                  stateDefaultValue: ' - ',
                  stateDateType: 'day',
                  stateWithSecond: false
                })}
              />

              <CompItem
                stateLabel='Tanggal Ambil : '
                stateContent={sqlDateToHumanDate({
                  stateDate: stateData.data[keyH].tanggal_ambil,
                  stateWithTime: false,
                  stateLang: 'id',
                  stateIsShort: false,
                  stateDay: false,
                  stateDefaultValue: ' - ',
                  stateDateType: 'day',
                  stateWithSecond: false
                })}
                stateMB="1.25rem"
              />

              <Text size='sm' fw={500}>
                Penggunaan Stok Item
              </Text>

              <Divider mt='sm' mb='0' />

              <Box mt={Number(indexH) === 0 ? '.75rem' : '1.25rem'} mb='lg'>
                {Array.isArray(stateData.data[keyH].pengerjaan) && (stateData.data[keyH].pengerjaan.length > 0) &&
                  Object.keys(stateData.data[keyH].pengerjaan).some((item) => stateData.data[keyH].pengerjaan[item].penggunaan_stock.length > 0) ?
                  Object.keys(stateData.data[keyH].pengerjaan).map((keyP, indexP) => {
                    return (
                      Array.isArray(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock) && (stateData.data[keyH].pengerjaan[keyP].penggunaan_stock.length > 0) && Object.keys(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock).map((keyPS, indexPS) => {
                        // ? ini dipake atau gak ? const stockStatus = stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_status;

                        //

                        const itemPengajuan = Object.values(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].item_in_garansi).filter(val => val.stock_garansi_detil_item_status === utils.statusItemGaransi.pengajuan_klaim_garansi.value);

                        const klaimSedangPengajuan = itemPengajuan.length;

                        //

                        const itemSudahDikirimKeSupplier = Object.values(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].item_in_garansi).filter(val => val.stock_garansi_detil_item_status === utils.statusItemGaransi.sudah_dikirim_ke_supplier.value);

                        const klaimSudahDikirimKeSupplier = itemSudahDikirimKeSupplier.length;

                        //

                        const itemMasukStok = Object.values(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].item_in_garansi).filter(val => val.stock_garansi_detil_item_status === utils.statusItemGaransi.masuk_stock.value);

                        const klaimItemMasukStock = itemMasukStok.length;

                        //

                        const itemKembaliUang = Object.values(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].item_in_garansi).filter(val => val.stock_garansi_detil_item_status === utils.statusItemGaransi.kembali_uang.value);

                        const klaimItemKembaliUang = itemKembaliUang.length;

                        //

                        const itemTidakKembali = Object.values(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].item_in_garansi).filter(val => val.stock_garansi_detil_item_status === utils.statusItemGaransi.item_tidak_akan_kembali.value);

                        const klaimItemTidakKembali = itemTidakKembali.length;

                        //

                        const klaimItemAll = Array.isArray(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].item_in_garansi) ? stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].item_in_garansi.length : 0;

                        return (
                          <Flex
                            key={keyPS}
                            wrap='nowrap'
                            gap="sm"
                            justify="flex-start"
                            align="flex-start"
                            mt='xs'
                          >
                            <Text size='sm'>{Number(keyPS) + 1}.</Text>

                            <Box sx={{ flex: 1 }}>
                              <Flex
                                wrap='nowrap'
                                gap="xs"
                                justify="flex-start"
                                align="flex-start"
                              >
                                <Flex
                                  wrap='nowrap'
                                  gap="xs"
                                  justify="flex-start"
                                  align="flex-start"
                                >
                                  <Text size='sm'>
                                    {safeValue(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_category_name, '[Kategori]')} {safeValue(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_category_sub_name, '[Sub Kategori]')} {safeValue(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_serial_number, '')}
                                  </Text>

                                  {/* <Badge
                                    size='md'
                                    color={getObjectParam2(utils.stockItemStatus, stockStatus, 'color', 'gray')}

                                    styles={(tema) => ({
                                      inner: {
                                        fontWeight: 'normal',
                                        textTransform: 'none',
                                        textOverflow: 'unset',
                                        overflow: 'unset'
                                      }
                                    })}
                                  >
                                    {getObjectParam2(utils.stockItemStatus, stockStatus, 'caption', ' - ')}
                                  </Badge> */}
                                </Flex>

                                {Boolean(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].can_be_claimed_customer) &&
                                  (Number(klaimItemAll) < (Number(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].project_pengerjaan_stock_jumlah_penggunaan))) &&
                                  canAccessModifyPengerjaan({ stateObject: { subLevel: loginContext } }) &&
                                  <Menu shadow="md" ml='auto'>
                                    <Menu.Target>
                                      <ActionIcon
                                        size='md'
                                        variant="subtle"
                                        radius='xl'

                                        sx={(tema) => ({
                                          backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[5],
                                          '&:hover': {
                                            backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[2] : tema.colors.dark[4]
                                          },
                                        })}
                                      >
                                        <IconDotsVertical size='1rem' />
                                      </ActionIcon>
                                    </Menu.Target>

                                    <Menu.Dropdown>
                                      <Menu.Item
                                        onClick={() => {
                                          setData(d => ({
                                            ...d,
                                            itemGaransiName: `${safeValue(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_category_name, '[Kategori]')} ${safeValue(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_category_sub_name, '[Sub Kategori]')} ${safeValue(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_serial_number, '')}`,
                                            itemGaransiStatus: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_status,
                                            itemGaransiType: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_masa_garansi_type,
                                            itemGaransiBulan: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_masa_garansi_bulan,
                                            itemGaransiHari: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_masa_garansi_hari,
                                            itemGaransiCanBeClaimedSupplier: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].can_be_claimed,
                                            itemGaransiCanBeClaimedCustomer: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].can_be_claimed_customer,
                                            itemGaransiTanggalBeli: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_tanggal_beli,
                                            itemGaransiTanggalSelesai: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].tanggal_selesai,
                                            itemReferensi: utils.garansiReference.project_pengerjaan_history.value,

                                            stockId: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_id,
                                            customerId: stateData.data[keyH].customer_id,
                                            projectIdHistory: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].project_id,
                                            projectId: stateData.projectId,
                                            projectPengerjaanStockId: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].project_pengerjaan_stock_id,

                                            klaimGaransiModal: true
                                          }))
                                        }}
                                      >
                                        Klaim Garansi
                                      </Menu.Item>
                                    </Menu.Dropdown>
                                  </Menu>
                                }
                              </Flex>

                              <Text size='sm' color='dimmed'>
                                Supplier : {stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].supplier_name}
                              </Text>

                              <Text size='sm' color='dimmed'>
                                Tanggal Beli : {sqlDateToHumanDate({
                                  stateDate: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_tanggal_beli,
                                  stateWithTime: false,
                                  stateLang: 'id',
                                  stateIsShort: false,
                                  stateDay: false,
                                  stateDefaultValue: ' - ',
                                  stateDateType: 'day',
                                  stateWithSecond: false
                                })}
                              </Text>

                              <Text size='sm' color="dimmed" mt='.25rem'>
                                Jumlah Pemakaian: {stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].project_pengerjaan_stock_jumlah_penggunaan}
                              </Text>

                              <Text size='sm' color="dimmed">
                                <Box>
                                  <Box>
                                    {masaGaransiUtils__2({
                                      stateGaransiType: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_masa_garansi_type,
                                      stateCanBeClaimed: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].can_be_claimed,
                                      stateCaptionCanBeClaimed: 'Item ini masih dapat diklaim ke supplier.',
                                      stateCaptionCannotBeClaimed: 'Item ini sudah tidak dapat diklaim ke supplier.'
                                    }).isCanBeClaimedCaption}
                                  </Box>

                                  <Box>
                                    {masaGaransiUtils__2({
                                      stateGaransiType: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].stock_masa_garansi_type,
                                      stateCanBeClaimed: stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].can_be_claimed_customer,
                                      stateCaptionCanBeClaimed: 'Item ini masih dapat diklaim oleh customer.',
                                      stateCaptionCannotBeClaimed: 'Item ini sudah tidak dapat diklaim oleh customer.'
                                    }).isCanBeClaimedCaption}
                                  </Box>
                                </Box>

                                {Array.isArray(stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].item_in_garansi) && (stateData.data[keyH].pengerjaan[keyP].penggunaan_stock[keyPS].item_in_garansi.length > 0) &&
                                  <Box mt='.25rem'>
                                    {klaimSedangPengajuan > 0 &&
                                      <Box mt='.5rem'>
                                        <Text size='sm'
                                          sx={(tema) => ({
                                            color: tema.colorScheme === 'light' ? tema.colors.red[7] : tema.colors.red[6]
                                          })}
                                        >
                                          {klaimSedangPengajuan} item dalam proses pengajuan klaim garansi.
                                        </Text>

                                        {itemPengajuan.map((keyPKG, indexPKG) => {
                                          return (
                                            <CompItemInGaransi
                                              key={keyH + '-' + keyP + '-' + keyPS + 'PKG'}
                                              stateIndex={indexPKG}
                                              stateKey={keyPKG}
                                            />
                                          )
                                        })}
                                      </Box>
                                    }

                                    {klaimSudahDikirimKeSupplier > 0 &&
                                      <Box mt='.5rem'>
                                        <Text size='sm'
                                          sx={(tema) => ({
                                            color: tema.colorScheme === 'light' ? tema.colors.red[7] : tema.colors.red[6]
                                          })}
                                        >
                                          {klaimSudahDikirimKeSupplier} item sudah dikirim ke supplier untuk klaim garansi.
                                        </Text>

                                        {itemSudahDikirimKeSupplier.map((keySDS, indexSDS) => {
                                          return (
                                            <CompItemInGaransi
                                              key={keyH + '-' + keyP + '-' + keyPS + 'SDS'}
                                              stateIndex={indexSDS}
                                              stateKey={keySDS}
                                            />
                                          )
                                        })}
                                      </Box>
                                    }

                                    {klaimItemMasukStock > 0 &&
                                      <Box mt='.5rem'>
                                        <Text size='sm'
                                          sx={(tema) => ({
                                            color: tema.colorScheme === 'light' ? tema.colors.red[7] : tema.colors.red[6]
                                          })}
                                        >
                                          {klaimItemMasukStock} item sudah pernah diklaim dan sudah masuk stok.
                                        </Text>

                                        {itemMasukStok.map((keyMS, indexMS) => {
                                          return (
                                            <CompItemInGaransi
                                              key={keyH + '-' + keyP + '-' + keyPS + 'MS' + indexMS}
                                              stateIndex={indexMS}
                                              stateKey={keyMS}
                                            />
                                          )
                                        })}
                                      </Box>
                                    }

                                    {klaimItemKembaliUang > 0 &&
                                      <Box mt='.5rem'>
                                        <Text size='sm'
                                          sx={(tema) => ({
                                            color: tema.colorScheme === 'light' ? tema.colors.red[7] : tema.colors.red[6]
                                          })}
                                        >
                                          {klaimItemKembaliUang} item sudah pernah diklaim dan dikembalikan berupa uang.
                                        </Text>

                                        {itemKembaliUang.map((keyKU, indexKU) => {
                                          return (
                                            <CompItemInGaransi
                                              key={keyH + '-' + keyP + '-' + keyPS + 'KU'}
                                              stateIndex={indexKU}
                                              stateKey={keyKU}
                                            />
                                          )
                                        })}
                                      </Box>
                                    }

                                    {klaimItemTidakKembali > 0 &&
                                      <Box mt='.5rem'>
                                        <Text size='sm'
                                          sx={(tema) => ({
                                            color: tema.colorScheme === 'light' ? tema.colors.red[7] : tema.colors.red[6]
                                          })}
                                        >
                                          {klaimItemTidakKembali} item sudah pernah diklaim dan tidak kembali.
                                        </Text>

                                        {itemTidakKembali.map((keyTK, indexTK) => {
                                          return (
                                            <CompItemInGaransi
                                              key={keyH + '-' + keyP + '-' + keyPS + 'TK'}
                                              stateIndex={indexTK}
                                              stateKey={keyTK}
                                            />
                                          )
                                        })}
                                      </Box>
                                    }
                                  </Box>
                                }
                              </Text>
                            </Box>
                          </Flex>
                        )
                      })
                    )
                  })
                  :
                  <Text size='sm' color="dimmed">
                    Tidak ada penggunaan stok item
                  </Text>
                }
              </Box>

              <Text size='sm' fw={500}>
                Tambahan Stok Item
              </Text>

              <Divider mt='sm' mb='0' />

              <Box mt={Number(indexH) === 0 ? '.75rem' : '1.25rem'}>
                {Array.isArray(stateData.data[keyH].tambahan_stock) && (stateData.data[keyH].tambahan_stock.length > 0) ? Object.keys(stateData.data[keyH].tambahan_stock).map((keyTMB, indexTMB) => {

                  // ? ini dipake atau ngga? const stockStatusTMB = stateData.data[keyH].tambahan_stock[keyTMB].stock_status;

                  //
                  const itemSedangPengajuanTMB = Object.values(stateData.data[keyH].tambahan_stock[keyTMB].item_in_garansi).filter(val => val.stock_garansi_detil_item_status === utils.statusItemGaransi.pengajuan_klaim_garansi.value);

                  const klaimSedangPengajuanTMB = itemSedangPengajuanTMB.length;

                  //

                  const itemSudahDikirimKeSupplierTMB = Object.values(stateData.data[keyH].tambahan_stock[keyTMB].item_in_garansi).filter(val => val.stock_garansi_detil_item_status === utils.statusItemGaransi.sudah_dikirim_ke_supplier.value);

                  const klaimSudahDikirimKeSupplierTMB = itemSudahDikirimKeSupplierTMB.length;

                  //

                  const itemItemMasukStockTMB = Object.values(stateData.data[keyH].tambahan_stock[keyTMB].item_in_garansi).filter(val => val.stock_garansi_detil_item_status === utils.statusItemGaransi.masuk_stock.value);

                  const klaimItemMasukStockTMB = itemItemMasukStockTMB.length;

                  //

                  const itemItemKembaliUangTMB = Object.values(stateData.data[keyH].tambahan_stock[keyTMB].item_in_garansi).filter(val => val.stock_garansi_detil_item_status === utils.statusItemGaransi.kembali_uang.value);

                  const klaimItemKembaliUangTMB = itemItemKembaliUangTMB.length;

                  //

                  const itemTidakKembaliTMB = Object.values(stateData.data[keyH].tambahan_stock[keyTMB].item_in_garansi).filter(val => val.stock_garansi_detil_item_status === utils.statusItemGaransi.item_tidak_akan_kembali.value);

                  const klaimItemTidakKembaliTMB = itemTidakKembaliTMB.length;

                  //

                  const klaimItemAllTMB = Array.isArray(stateData.data[keyH].tambahan_stock[keyTMB].item_in_garansi) ? stateData.data[keyH].tambahan_stock[keyTMB].item_in_garansi.length : 0;

                  return (
                    <Flex
                      key={keyTMB}
                      wrap='nowrap'
                      gap="sm"
                      justify="flex-start"
                      align="flex-start"
                      mt='xs'
                    >
                      <Text size='sm'>{Number(keyTMB) + 1}.</Text>

                      <Box sx={{ flex: 1 }}>
                        <Flex
                          wrap='nowrap'
                          gap="xs"
                          justify="flex-start"
                          align="flex-start"
                        >
                          <Flex
                            wrap='nowrap'
                            gap="xs"
                            justify="flex-start"
                            align="flex-start"
                          >
                            <Text size='sm'>
                              {safeValue(stateData.data[keyH].tambahan_stock[keyTMB].stock_category_name, '[Kategori]')} {safeValue(stateData.data[keyH].tambahan_stock[keyTMB].stock_category_sub_name, '[Sub Kategori]')} {safeValue(stateData.data[keyH].tambahan_stock[keyTMB].stock_serial_number, '')}
                            </Text>

                            {/* <Badge
                              size='md'
                              color={getObjectParam2(utils.stockItemStatus, stockStatusTMB, 'color', 'gray')}

                              styles={(tema) => ({
                                inner: {
                                  fontWeight: 'normal',
                                  textTransform: 'none',
                                  textOverflow: 'unset',
                                  overflow: 'unset'
                                }
                              })}
                            >
                              {getObjectParam2(utils.stockItemStatus, stockStatusTMB, 'caption', ' - ')}
                            </Badge> */}
                          </Flex>

                          {Boolean(stateData.data[keyH].tambahan_stock[keyTMB].can_be_claimed_customer) &&
                            (Number(klaimItemAllTMB) < (Number(stateData.data[keyH].tambahan_stock[keyTMB].project_tambahan_stock_jumlah_penggunaan))) &&
                            canAccessModifyPengerjaan({ stateObject: { subLevel: loginContext } }) &&
                            <Menu shadow="md" ml='auto'>
                              <Menu.Target>
                                <ActionIcon
                                  size='md'
                                  variant="subtle"
                                  radius='xl'

                                  sx={(tema) => ({
                                    backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[5],
                                    '&:hover': {
                                      backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[2] : tema.colors.dark[4]
                                    },
                                  })}
                                >
                                  <IconDotsVertical size='1rem' />
                                </ActionIcon>
                              </Menu.Target>

                              <Menu.Dropdown>
                                <Menu.Item
                                  onClick={() => {
                                    setData(d => ({
                                      ...d,
                                      itemGaransiName: `${safeValue(stateData.data[keyH].tambahan_stock[keyTMB].stock_category_name, '[Kategori]')} ${safeValue(stateData.data[keyH].tambahan_stock[keyTMB].stock_category_sub_name, '[Sub Kategori]')} ${safeValue(stateData.data[keyH].tambahan_stock[keyTMB].stock_serial_number, '')}`,
                                      itemGaransiStatus: stateData.data[keyH].tambahan_stock[keyTMB].stock_status,
                                      itemGaransiType: stateData.data[keyH].tambahan_stock[keyTMB].stock_masa_garansi_type,
                                      itemGaransiBulan: stateData.data[keyH].tambahan_stock[keyTMB].stock_masa_garansi_bulan,
                                      itemGaransiHari: stateData.data[keyH].tambahan_stock[keyTMB].stock_masa_garansi_hari,
                                      itemGaransiCanBeClaimedSupplier: stateData.data[keyH].tambahan_stock[keyTMB].can_be_claimed,
                                      itemGaransiCanBeClaimedCustomer: stateData.data[keyH].tambahan_stock[keyTMB].can_be_claimed_customer,
                                      itemGaransiTanggalBeli: stateData.data[keyH].tambahan_stock[keyTMB].stock_tanggal_beli,
                                      itemGaransiTanggalSelesai: stateData.data[keyH].tambahan_stock[keyTMB].tanggal_selesai,
                                      itemReferensi: utils.garansiReference.project_tambahan_stock.value,

                                      stockId: stateData.data[keyH].tambahan_stock[keyTMB].stock_id,
                                      customerId: stateData.data[keyH].customer_id,
                                      projectIdHistory: stateData.data[keyH].tambahan_stock[keyTMB].project_id,
                                      projectId: stateData.projectId,
                                      projectPengerjaanStockId: stateData.data[keyH].tambahan_stock[keyTMB].project_tambahan_stock_id,

                                      klaimGaransiModal: true
                                    }))
                                  }}
                                >
                                  Klaim Garansi
                                </Menu.Item>
                              </Menu.Dropdown>
                            </Menu>
                          }
                        </Flex>

                        <Text size='sm' color='dimmed'>
                          Supplier : {stateData.data[keyH].tambahan_stock[keyTMB].supplier_name}
                        </Text>

                        <Text size='sm' color="dimmed">
                          Jumlah Pemakaian: {stateData.data[keyH].tambahan_stock[keyTMB].project_tambahan_stock_jumlah_penggunaan}
                        </Text>

                        <Text size='sm' color="dimmed">
                          <Box>
                            <Box>
                              {masaGaransiUtils__2({
                                stateGaransiType: stateData.data[keyH].tambahan_stock[keyTMB].stock_masa_garansi_type,
                                stateCanBeClaimed: stateData.data[keyH].tambahan_stock[keyTMB].can_be_claimed,
                                stateCaptionCanBeClaimed: 'Item ini masih dapat diklaim ke supplier.',
                                stateCaptionCannotBeClaimed: 'Item ini sudah tidak dapat diklaim ke supplier.'
                              }).isCanBeClaimedCaption}
                            </Box>

                            <Box>
                              {masaGaransiUtils__2({
                                stateGaransiType: stateData.data[keyH].tambahan_stock[keyTMB].stock_masa_garansi_type,
                                stateCanBeClaimed: stateData.data[keyH].tambahan_stock[keyTMB].can_be_claimed_customer,
                                stateCaptionCanBeClaimed: 'Item ini masih dapat diklaim oleh customer.',
                                stateCaptionCannotBeClaimed: 'Item ini sudah tidak dapat diklaim oleh customer.'
                              }).isCanBeClaimedCaption}
                            </Box>
                          </Box>

                          {Array.isArray(stateData.data[keyH].tambahan_stock[keyTMB].item_in_garansi) && (stateData.data[keyH].tambahan_stock[keyTMB].item_in_garansi.length > 0) &&
                            <Box mt='.25rem'>
                              {klaimSedangPengajuanTMB > 0 &&
                                <Box mt='.5rem'>
                                  <Text size='sm'
                                    sx={(tema) => ({
                                      color: tema.colorScheme === 'light' ? tema.colors.red[7] : tema.colors.red[6]
                                    })}
                                  >
                                    {klaimSedangPengajuanTMB} item dalam proses pengajuan klaim garansi.
                                  </Text>

                                  {itemSedangPengajuanTMB.map((keySPK, indexSPK) => {
                                    return (
                                      <CompItemInGaransi
                                        key={keyH + '-' + keyTMB + '-TMB_SPK'}
                                        stateIndex={indexSPK}
                                        stateKey={keySPK}
                                      />
                                    )
                                  })}
                                </Box>
                              }

                              {klaimSudahDikirimKeSupplierTMB > 0 &&
                                <Box mt='.5rem'>
                                  <Text size='sm'
                                    sx={(tema) => ({
                                      color: tema.colorScheme === 'light' ? tema.colors.red[7] : tema.colors.red[6]
                                    })}
                                  >
                                    {klaimSudahDikirimKeSupplierTMB} item sudah dikirim ke supplier untuk klaim garansi.
                                  </Text>

                                  {itemSudahDikirimKeSupplierTMB.map((keySDSTMB, indexSDSTMB) => {
                                    return (
                                      <CompItemInGaransi
                                        key={keyH + '-' + keyTMB + '-TMB_SDS'}
                                        stateIndex={indexSDSTMB}
                                        stateKey={keySDSTMB}
                                      />
                                    )
                                  })}
                                </Box>
                              }

                              {klaimItemMasukStockTMB > 0 &&
                                <Box mt='.5rem'>
                                  <Text size='sm'
                                    sx={(tema) => ({
                                      color: tema.colorScheme === 'light' ? tema.colors.red[7] : tema.colors.red[6]
                                    })}
                                  >
                                    {klaimItemMasukStockTMB} item sudah pernah diklaim dan sudah masuk stok.
                                  </Text>

                                  {itemItemMasukStockTMB.map((keyMSTMB, indexMSTMB) => {
                                    return (
                                      <CompItemInGaransi
                                        key={keyH + '-' + keyTMB + '-TMB_MS'}
                                        stateIndex={indexMSTMB}
                                        stateKey={keyMSTMB}
                                      />
                                    )
                                  })}
                                </Box>
                              }

                              {klaimItemKembaliUangTMB > 0 &&
                                <Box mt='.5rem'>
                                  <Text size='sm'
                                    sx={(tema) => ({
                                      color: tema.colorScheme === 'light' ? tema.colors.red[7] : tema.colors.red[6]
                                    })}
                                  >
                                    {klaimItemKembaliUangTMB} item sudah pernah diklaim dan dikembalikan berupa uang.
                                  </Text>

                                  {itemItemKembaliUangTMB.map((keyKUTMB, indexKUTMB) => {
                                    return (
                                      <CompItemInGaransi
                                        key={keyH + '-' + keyTMB + '-TMB_KU'}
                                        stateIndex={indexKUTMB}
                                        stateKey={keyKUTMB}
                                      />
                                    )
                                  })}
                                </Box>
                              }

                              {klaimItemTidakKembaliTMB > 0 &&
                                <Box mt='.5rem'>
                                  <Text size='sm'
                                    sx={(tema) => ({
                                      color: tema.colorScheme === 'light' ? tema.colors.red[7] : tema.colors.red[6]
                                    })}
                                  >
                                    {klaimItemTidakKembaliTMB} item sudah pernah diklaim dan tidak kembali.
                                  </Text>

                                  {itemTidakKembaliTMB.map((keyTKTMB, indexTKTMB) => {
                                    return (
                                      <CompItemInGaransi
                                        key={keyH + '-' + keyTMB + '-TMB_TK'}
                                        stateIndex={indexTKTMB}
                                        stateKey={keyTKTMB}
                                      />
                                    )
                                  })}
                                </Box>
                              }
                            </Box>
                          }
                        </Text>
                      </Box>
                    </Flex>
                  )
                })
                  :
                  <Text size='sm' color="dimmed">
                    Tidak ada tambahan stok item
                  </Text>
                }
              </Box>
            </PaperWrapper>
          )
        })}
      </ScrollArea.Autosize>

      <ModalTakeAction
        stateShow={data.klaimGaransiModal}
        fnHide={() => setData(d => ({ ...d, klaimGaransiModal: false }))}

        stateHideOnClickOutSide={false}
        stateTitle={String('Klaim Garansi').toUpperCase()}
        stateOverlayZIndex={201}
        stateScrollArea={true}

        stateButtonClosePx='md'
        stateSize="lg"

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor=""
        stateButtonActionLoading={data.klaimGaransiSubmitLoading}
        fnButtonAction={klaimGaransiHistoryStock}
      >
        <Paper
          mt='sm'
          p='sm'
          sx={(tema) => ({
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.5) : tema.fn.rgba(tema.colors.blue[9], 0.5),
            borderRadius: tema.radius.sm,
            fontSize: tema.fontSizes.sm,
          })}
        >
          <LabelContentInline
            stateColLabel={3}
            stateLabel='Item'
            stateContent={
              <Group spacing='xs'>
                <Text>{data.itemGaransiName}</Text>
                {/* <Badge
                  size='md'
                  color={getObjectParam2(utils.stockItemStatus, data.itemGaransiStatus, 'color', 'gray')}

                  styles={() => ({
                    inner: {
                      fontWeight: 'normal',
                    }
                  })}
                >
                  {getObjectParam2(utils.stockItemStatus, data.itemGaransiStatus, 'caption', ' - ')}
                </Badge> */}
              </Group>
            }
            stateDivider={false}
          />

          <LabelContentInline
            stateColLabel={3}
            stateLabel='Garansi Supplier'
            stateContent={masaGaransiUtils__1({
              stateGaransiType: data.itemGaransiType,
              stateGaransiBulan: data.itemGaransiBulan,
              stateGaransiHari: data.itemGaransiHari,
              stateTanggalPembelian: data.itemGaransiTanggalBeli,
              stateShowTanggalPembelian: true,
            })}
            stateDivider={false}
          />

          {/* <LabelContentInline
                stateColLabel={3}
                stateLabel='Garansi Client'
                stateContent={masaGaransiUtils__1({
                stateGaransiType: data.batalPemakaianItemData.masaGaransiType,
                stateGaransiBulan: data.batalPemakaianItemData.masaGaransiBulan,
                stateGaransiHari: data.batalPemakaianItemData.masaGaransiHari,
                stateTanggalPembelian: data.batalPemakaianItemData.tanggalPembelian,
                stateShowTanggalPembelian: true,
                })}
                stateDivider={false}
          /> */}

          <LabelContentInline
            stateColLabel={0}
            stateLabel=''
            stateContent={
              <Text
                color={masaGaransiUtils__2({
                  stateGaransiType: data.itemGaransiType,
                  stateCanBeClaimed: data.itemGaransiCanBeClaimedSupplier,
                }).colorCanBeClaimed}
              >
                {masaGaransiUtils__2({
                  stateGaransiType: data.itemGaransiType,
                  stateCanBeClaimed: data.itemGaransiCanBeClaimedSupplier,
                  stateCaptionCanBeClaimed: 'Item ini masih dapat diklaim ke supplier.',
                  stateCaptionCannotBeClaimed: 'Item ini sudah tidak dapat diklaim ke supplier.'
                }).isCanBeClaimedCaption}
              </Text>
            }
            stateDivider={false}
          />

          <LabelContentInline
            stateColLabel={0}
            stateLabel=''
            stateContent={
              <Text
                color={masaGaransiUtils__2({
                  stateGaransiType: data.itemGaransiType,
                  stateCanBeClaimed: data.itemGaransiCanBeClaimedCustomer,
                }).colorCanBeClaimed}
              >
                {masaGaransiUtils__2({
                  stateGaransiType: data.itemGaransiType,
                  stateCanBeClaimed: data.itemGaransiCanBeClaimedCustomer,
                  stateCaptionCanBeClaimed: 'Item ini masih dapat diklaim oleh customer.',
                  stateCaptionCannotBeClaimed: 'Item ini sudah tidak dapat diklaim oleh customer.'
                }).isCanBeClaimedCaption}
              </Text>
            }
            stateDivider={false}
          />
        </Paper>

        <Box
          my='1rem'
        >
          <InputComponent
            stateId='klaim-jumlah'
            stateWithAsterisk={false}
            stateLabel='Jumlah item yang akan diklaim'
            stateDescription=''
            statePlaceHolder='Jumlah'
            stateValue={data.itemGaransiJumlah}
            stateError=''

            fnOnChange={(e) => setData(d => ({
              ...d,
              itemGaransiJumlah: regexNumberOnly(e.target.value)
            }))}
          />
        </Box>

        <Textarea
          value={data.itemGaransiKeterangan}
          minRows={4}
          maxRows={5}
          onChange={(e) =>
            setData(d => ({
              ...d,
              itemGaransiKeterangan: e.target.value
            }))
          }

          label='Keterangan Klaim'
          placeholder='Keterangan'
          error=''
          description=''
          withAsterisk={false}
          mb='sm'
        />

        {data.klaimGaransiSubmitError &&
          <Text size='sm' color="red" mt='sm'>
            {data.klaimGaransiSubmitError}
          </Text>
        }
      </ModalTakeAction>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />
    </React.Fragment>
  )
}

export default React.memo(HistoryProjectCustomerData);